module.exports = "<div role=\"group\" aria-label=\"Basic example\" v-bind:class=\"{ 'btn-group': true, 'btn-group-vertical': vertical }\">\n\t<slot></slot>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/components/button-group/button-group.html
// module id = 11
// module chunks = 0